import React, { useContext, useEffect, useState } from 'react';
import { WizardContext } from 'context/Context';
import { useNavigate } from 'react-router-dom';
import { Form, Row, Button, Alert } from 'react-bootstrap';
import Wrapper from './components/Wrapper';
import { getTimeWindow } from './components/Confirmed';
import { ConfigContext } from 'context/Context';
import Video2 from './components/Video2';

function ConfirmTemplate() {
  const { fabricator } = useContext(ConfigContext);
  const { job, handleAppointmentConfirmation } = useContext(WizardContext);
  const navigate = useNavigate();
  const [decision, setDecision] = useState('');
  const [rescheduleConfirm, setRescheduleConfirm] = useState(false);
  const [reason, setReason] = useState('');
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    // console.log('template status', job?.template?.status);
    console.log('job', job);
    if (
      job.id &&
      (!job.template ||
        job?.template?.reschedule ||
        job?.template?.status === 'Templated' ||
        job?.template?.status === 'In Progress')
    ) {
      navigate('../');
    }
  }, [job.id, job?.template?.status]);

  useEffect(() => {
    if (job?.template?.windowAnswered) {
      setDecided(true);
      if (job.template.windowConfirmed) {
        setDecision('confirm');
      } else if (job.template.reschedule) {
        setDecision('reschedule');
      } else {
        navigate('../');
      }
    }
  }, [job?.template]);

  return decided ? (
    <Wrapper>
      <div className="container">
        <h5>Template Arrival Window Confirmed</h5>
        <p>Awesome! We can't wait to see you! </p>
        <p>
          To make sure everything goes smoothly, check out this little video for
          more information on how to be ready:
        </p>
        <Video2
          file={
            'https://library.countertopwizard.com/OtherAsset%2Fcw-confirmations%2FTemplate%20Explainer.mp4'
          }
        />

        <p>Quick Checklist to be ready:</p>
        <ul>
          <li>Sink, faucet, & range on-site</li>
        </ul>
        {job?.sinkInfo?.type?.match(/farm/) && (
          <Alert variant="secondary">
            Since you are supplying a farm sink, it needs to be resting in place
            but not glued down when our technician comes to measure.
          </Alert>
        )}
        <ul>
          <li>
            New cabinets fully installed including all end panels (or existing
            cabinets cleared off)
          </li>
        </ul>
        <ul>
          <li>Decision-maker (18+) on-site for the entire appointment</li>
        </ul>
        <Alert variant="secondary">
          Note: If we’re unable to template due to unpreparedness, there will be
          an "unable to template" fee.
        </Alert>
        <p>See you soon! Let us know if you have any questions.</p>
        <p style={{ fontStyle: 'italic' }}>
          If you have an emergency that requires you to reschedule, please call{' '}
          <a href={fabricator.phonelink}>{fabricator.phone}</a>
        </p>
      </div>
    </Wrapper>
  ) : (
    <Wrapper>
      <div className="container">
        <h5>Confirm Template Arrival Window</h5>

        <Row>
          <p>
            We are ready to get started! Let’s confirm your TEMPLATE appointment
            is scheduled for {job?.template?.dateFormatted} with our team set to
            arrive between{' '}
            <strong>
              {job?.template?.time && getTimeWindow(job?.template?.time)}
            </strong>
            .
          </p>
          <p>Click your choice below to move forward with your project:</p>
        </Row>

        <Form className="outdoor-field">
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="decision"
              id="confirm"
              label={`Perfect - see you there`}
              checked={decision === 'confirm'}
              onChange={() => {
                setDecision('confirm');
              }}
            />
          </Row>
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="reschedule"
              id="yes"
              label={<>I need to reschedule</>}
              checked={decision === 'reschedule'}
              onChange={() => {
                setDecision('reschedule');
              }}
            />
          </Row>
        </Form>
        {decision === 'reschedule' && (
          <>
            <p>Are you sure you need to reschedule?</p>
            <p>
              Just a heads up - if we reschedule, we'll have to find the next
              available date. Let us know what works best for you!
            </p>
            <Form>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="textOK"
                  label="Yes, please contact me to reschedule"
                  checked={rescheduleConfirm}
                  onChange={({ target }) =>
                    setRescheduleConfirm(target.checked)
                  }
                  inline
                />
              </Form.Group>
              {rescheduleConfirm && (
                <>
                  <p className="fs--1" style={{ fontStyle: 'italic' }}>
                    Are there any scheduling concerns we should be aware of
                    while we look for a new date for you?{' '}
                  </p>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      bssize="sm"
                      id="experienceDescription"
                      value={reason}
                      onChange={({ target }) => setReason(target.value)}
                      rows={5}
                      className="mb-3"
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          </>
        )}
        <Button
          color="primary"
          className="mx-2 my-1 save-comment-btn"
          disabled={
            !decision || (decision === 'reschedule' && !rescheduleConfirm)
          }
          onClick={() => {
            handleAppointmentConfirmation({
              type: 'template',
              decision,
              reason
            });
            if (decision === 'confirm') {
              setDecided(true);
            } else {
              navigate('../');
            }
          }}
        >
          Submit My Selection
        </Button>
      </div>
    </Wrapper>
  );
}

export default ConfirmTemplate;
